export enum InvoiceDetailsActivitiesColumns {
  RegDate,
  Description,
  ActionDate,
  Claim,
  Fee,
  Interest,
  Paid,
}
